export default __webpack_public_path__ + "static/hero-img-e3e4c42c0f8942e3acddaea39078857b.png";